import { Component, OnInit,ViewChild } from '@angular/core';
import { SelectItem, Message } from 'primeng/primeng';
import { PositionService} from '../services/position.service';
import { UserService } from '../services/user.service';
import { AddressService } from '../services/address.service';
import { DriverService} from '../services/driver.service';
import { Table } from 'primeng/components/table/table';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-alarm-driver-report',
  templateUrl: './alarm-driver-report.component.html',
  styleUrls: ['./alarm-driver-report.component.css']
})
export class AlarmDriverReportComponent implements OnInit {
  fileName:String;
  options: any;
  overlays: any[];
  position:any;
  positions : any [];
  //alarmTypes: SelectItem[];
  drivers: SelectItem[];
  dateOptions: SelectItem[];
  dateOption: any;
  idDriver: number;
  idAlarmType: String;
  disabledInitialDate: boolean;
  disabledFinalDate: boolean;
  initialDate: Date;
  finalDate: Date;
  msgs: Message[] = [];
  blockedDocument: boolean = false;
  cols: any[];
  displayLocation: boolean=false;
  maxDays:number=35;
  alarmCounters:any[];

  @ViewChild('dt') table: Table;

  constructor(private positionService:PositionService,private driverService : DriverService,
    private userService: UserService,private addressService:AddressService) { }

    ngOnInit() {
      this.cols = [
              { field: 'nameDevice', header: 'NOMBRE' },
              { field: 'nameDriver', header: 'CONDUCTOR' },
              { field: 'deviceTime', header: 'FECHA/HORA' },
              { field: 'latLng', header: 'POSICION' },
              { field: 'alarmDescription', header: 'ALARMA' },
              { field: 'speed', header: 'VELOCIDAD'},
              { field: 'address', header: 'DIRECCION' }
          ];
      this.dateOptions = [
        {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
        {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
        {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
        {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
      ];

      this.drivers = [];

      if(this.userService.userLoged.idCompany == null || this.userService.userLoged.idCompany == undefined){
        this.driverService.findAll().then(data => {
          let response: any = data;
          response.drivers.forEach(item => {
            this.drivers.push({label: item.name, value: item.idDriver});
          });
        }).catch(err =>{
          console.log(err);
          this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        });
      }else{
        this.driverService.findByCompany(this.userService.userLoged.idCompany).then(data => {
          let response: any = data;
          response.drivers.forEach(item => {
            this.drivers.push({label: item.name, value: item.idDriver});
          });
        }).catch(err =>{
          console.log(err);
          this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        });
      }

    /*  this.alarmTypes = [];
      this.alarmTypeService.findByStatus("H").then(data => {
        let response: any = data;
        response.alarmTypes.forEach(item => {
          this.alarmTypes.push({label: item.description, value: item.idAlarmType});
        });
      }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      });*/

      this.dateOption = '7';
      this.changeDate();
    }

    changeDate(){
      this.disabledInitialDate = true;
      this.disabledFinalDate = true;
      if(this.dateOption == 'T'){
        this.initialDate = new Date();
        this.finalDate = new Date();
        this.initialDate.setHours(0,0,0);
        this.finalDate.setHours(23,59,59);
      }else if(this.dateOption == 'Y'){
        this.initialDate = new Date();
        this.finalDate = new Date();
        this.initialDate.setDate(this.initialDate.getDate() - 1);
        this.initialDate.setHours(0,0,0);
        this.finalDate.setDate(this.finalDate.getDate() - 1);
        this.finalDate.setHours(23,59,59);
      }else if(this.dateOption == '7'){
        this.initialDate = new Date();
        this.finalDate = new Date();
        this.initialDate.setDate(this.initialDate.getDate() - 6);
        this.initialDate.setHours(0,0,0);
        this.finalDate.setHours(23,59,59);
      }else{
        this.disabledInitialDate = false;
        this.disabledFinalDate = false;
      }
    }

    diferenciaEntreFechasEnDias(a:Date, b:Date):number{
      return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
    }

    buscar(){
      if(this.table){
        this.table.first=1;
      }

      this.fileName="Reporte_de_Alarmas_";
      this.drivers.forEach(item =>{
        if(item.value == this.idDriver){
          this.fileName = this.fileName+item.label;
        }
      });
      if(this.diferenciaEntreFechasEnDias(this.initialDate,this.finalDate) > this.maxDays){
        this.msgs = [{severity:'error', summary:'ERROR', detail:"El rango de fechas no debe exceder los "+this.maxDays+" dias"}];
        return;
      }
      if(this.initialDate >= this.finalDate){
        this.msgs = [{severity:'error', summary:'ERROR', detail:"La fecha final debe ser superior a la fecha inicial"}];
        return;
      }

      this.blockedDocument = true;
      this.positions = [];
      this.positionService.findDriverAlarms(this.idDriver,this.initialDate,this.finalDate,this.userService.userLoged.idUser).then(data => {
        let response: any = data;
        this.alarmCounters = [];
        response.positions.forEach(item => {
          item.latitude = item.latitude.toFixed(6);
          item.longitude = item.longitude.toFixed(6);
          item.latLng = item.latitude+", "+item.longitude
          item.speed = item.speed.toFixed(2);

          let index:number = item.extended.indexOf(item.extended.find(x => x.key == "driverUniqueId"));
          item.nameDriver = item.extended[index].value;

          if(item.alarm=="overspeed" || item.alarm=="hardAcceleration" || item.alarm=="hardBraking" || item.alarm=="leisure"){
            let count = this.alarmCounters.find(i => i.name == item.alarmDescription);
            if (count){
              count.value = count.value+1;
            }else{
              this.alarmCounters.push({name:item.alarmDescription, value: 1});
            }
            this.positions.push(item);
          }
        });
        this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
      });
    }

    showInMap(position:any){
      this.overlays = [];
      this.displayLocation = true;
      let latLng = new google.maps.LatLng(position.latitude, position.longitude);
      this.options = {
        zoom: 13,
        center:latLng
      };
      let marker = new google.maps.Marker({position: latLng});
      this.position = position;
      this.overlays.push(marker);
    }

    hide(){
      this.displayLocation = false;
    }

    getAddress(position:any){
      this.blockedDocument = true;
      this.addressService.findAddressByCoordinates(position).then(data =>{
        let response: any = data;
          if(response.status == 'OK'){
            position.address = response.address;
            this.msgs = [{severity:'info', summary:'INFO', detail:'Dirección obtenida Exitosamente'}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
          this.blockedDocument = false;
      });;
    }

    exportXLS(){
      let records = [];
      this.positions.forEach(item=>{
        let data = {};
        this.cols.forEach(col => {
          data[col.header] = item[col.field];
        });
        records.push(data);
      });

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
      const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
      XLSX.writeFile(workbook, this.fileName+".xlsx");
    }
}



// WEBPACK FOOTER //
// ./src/app/alarm-driver-report/alarm-driver-report.component.ts